import { render, staticRenderFns } from "./ScannerPlugin.vue?vue&type=template&id=52de862c&scoped=true"
import script from "./ScannerPlugin.vue?vue&type=script&lang=js"
export * from "./ScannerPlugin.vue?vue&type=script&lang=js"
import style0 from "./ScannerPlugin.vue?vue&type=style&index=0&id=52de862c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52de862c",
  null
  
)

export default component.exports